const AIAlgorithms = () => {
  return (
    <div>
      <p>
        Programs that implement computational intelligence algorithms to solve
        problems correctly and efficiently.
      </p>
      <br />
      <strong>Search: Sokoban Puzzle</strong>
      <p>
        Solves a Sokoban Puzzle using DFS and A* search algorithms with
        heuristic functions. ‍
      </p>
      <br />
      <strong>Games: Mancala</strong>
      <p>
        Plays the Mancala game using the depth-first minimax algorithm and
        alpha-beta pruning.
      </p>
      <br />
      <strong>CSP: Kropki Sudoku</strong>
      <p>
        Solves a Kropki Sudoku puzzle using forward checking, AC-3, and the
        minimum-remaining-values heuristic.
      </p>
      <br />
      <strong>Uncertainty: Naive Bayes Model</strong>
      <p>
        Predicts the salaries of people who lived in the United States in 1994
        using a Naive Bayes model and the variable elimination algorithm to
        calculate probabilities.
      </p>
    </div>
  );
};

export default AIAlgorithms;
